var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.data.length
    ? _c(
        "div",
        { staticClass: "hp-sustain" },
        [
          _c(
            "z-caption",
            {
              staticClass: "u-bottom-margin--4-xl-important",
              attrs: {
                size: "xl",
                tag: "h2",
                uppercase: "",
                weight: "900",
                href:
                  "/" + _vm.$root.lang + "/sustainability/approach-and-policy/",
              },
            },
            [_c("span", { domProps: { innerHTML: _vm._s(_vm.text.title) } })]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "row" },
            _vm._l(_vm.data, function (item, index) {
              return _c(
                "div",
                {
                  key: index,
                  staticClass: "col-default-4 col-tablet-6 col-mobile-12",
                },
                [
                  _c("preview-card", {
                    staticClass: "hp-sustain-card",
                    attrs: {
                      "full-height": "",
                      image: item.previewPicture.link,
                      title: item.name,
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "detail",
                          fn: function () {
                            return [
                              _c(
                                "div",
                                { staticClass: "hp-sustain-card__content" },
                                [
                                  _c(
                                    "z-caption",
                                    {
                                      staticClass: "hp-sustain-card__title",
                                      attrs: { tag: "p", size: "l" },
                                    },
                                    [
                                      _c("span", {
                                        domProps: {
                                          innerHTML: _vm._s(item.name),
                                        },
                                      }),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  item.previewText
                                    ? _c("p", {
                                        staticClass:
                                          "white-text u-bottom-margin--2-xs",
                                        domProps: {
                                          innerHTML: _vm._s(item.previewText),
                                        },
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  item.staticDetailLink &&
                                  item.staticDetailLink.value
                                    ? _c(
                                        "z-button",
                                        {
                                          staticClass: "white-text",
                                          attrs: {
                                            tag: "a",
                                            href: item.staticDetailLink.value,
                                            kind: "text",
                                            size: "m",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "right",
                                                fn: function () {
                                                  return [
                                                    _c("z-icon", {
                                                      attrs: {
                                                        name: "arrow_long",
                                                        dir: "right",
                                                        width: "40",
                                                        height: "24",
                                                        color: "#fff",
                                                      },
                                                    }),
                                                  ]
                                                },
                                                proxy: true,
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        },
                                        [
                                          _c("span", {
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.text.readMore
                                              ),
                                            },
                                          }),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  item.newsLink && item.newsLink.detailPageUrl
                                    ? _c(
                                        "div",
                                        { staticClass: "hp-sustain__news" },
                                        [
                                          _c(
                                            "z-caption",
                                            {
                                              staticClass:
                                                "white-text u-bottom-margin--2xs-important",
                                              attrs: {
                                                size: "m",
                                                weight: "600",
                                                tag: "p",
                                              },
                                            },
                                            [
                                              _c("span", {
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    _vm.text.relatedNews
                                                  ),
                                                },
                                              }),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "hp-sustain-news" },
                                            [
                                              item.newsLink.previewPicture &&
                                              item.newsLink.previewPicture.link
                                                ? _c("div", {
                                                    staticClass:
                                                      "hp-sustain-news__img",
                                                    style:
                                                      "background-image: url(" +
                                                      item.newsLink
                                                        .previewPicture.link +
                                                      ");",
                                                  })
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "hp-sustain-news__info",
                                                },
                                                [
                                                  _c(
                                                    "z-link",
                                                    {
                                                      staticClass:
                                                        "hp-sustain-news__title",
                                                      attrs: {
                                                        theme: "white",
                                                        href: item.newsLink
                                                          .detailPageUrl,
                                                      },
                                                    },
                                                    [
                                                      _c("span", {
                                                        domProps: {
                                                          innerHTML: _vm._s(
                                                            item.newsLink.name
                                                          ),
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  item.newsLink.activeFrom
                                                    ? _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "hp-sustain-news__date",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                                        " +
                                                              _vm._s(
                                                                _vm._f(
                                                                  "momentFilter"
                                                                )(
                                                                  item.newsLink
                                                                    .activeFrom,
                                                                  "DD MMMM YYYY"
                                                                )
                                                              ) +
                                                              "\n                                    "
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ],
                                                1
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      true
                    ),
                  }),
                ],
                1
              )
            }),
            0
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }